import { el, on } from '@/lib/dom';
import { ICON } from '../icons';

export type SeedOpts = {
  label: string;
  value: number;
  onChange: (v: number) => void;
};

export function seedControl(opts: SeedOpts): HTMLElement {
  const input = el('input', { type: 'text', value: String(opts.value), ariaLabel: opts.label }) as HTMLInputElement;
  input.className = 'sd-input mono';

  const reroll = el('button', { class: 'btn-icon', ariaLabel: 'New seed', innerHTML: ICON.shuffle });

  on(input, 'change', () => {
    const n = parseInt(input.value, 10);
    if (Number.isFinite(n)) opts.onChange(n);
    else input.value = String(opts.value);
  });
  on(reroll, 'click', () => {
    const n = Math.floor(Math.random() * 0x7fffffff);
    input.value = String(n);
    opts.onChange(n);
  });

  return el('div', { class: 'sd' }, [
    el('div', { class: 'sl-row' }, [el('span', { class: 'sl-label' }, [opts.label])]),
    el('div', { class: 'sd-row' }, [input, reroll]),
  ]);
}
